<template>
  <div class="leftMenu">
    <el-menu
      :default-active="routePate"
      :unique-opened="true"
      @select="handleSelect"
    >
      <template v-for="item in leftRouterFilter(leftRouter)" :key="item.path">
        <el-sub-menu
          v-if="item.children?.length"
          :index="handlePath(item)"
        >
          <template #title>
            <span>{{ $t(item?.meta?.title) }}</span>
          </template>
          <template v-for="child in item.children" :key="child.path">
            <el-sub-menu
              v-if="child.children?.length"
              :index="handlePath(item, child)"
            >
              <template #title>
                <span>{{ $t(child?.meta?.title) }}</span>
              </template>
              <template v-for="layer in child.children" :key="layer.path">
                <el-menu-item :index="handlePath(item, child, layer)">
                  <template #title>
                    <span>{{ $t(layer?.meta?.title) }}</span>
                  </template>
                </el-menu-item>
              </template>
            </el-sub-menu>
            <el-menu-item v-else :index="handlePath(item, child)">
              <template #title>
                <span>{{ $t(child?.meta?.title) }}</span>
              </template>
            </el-menu-item>
          </template>
        </el-sub-menu>
        <el-menu-item v-else :index="handlePath(item)">
          <template #title>
            <span>{{ $t(item?.meta?.title) }}</span>
          </template>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

const store = useStore();
const router = useRouter();
const route = useRoute();
const routePate = computed(() => route.path);
const isTopMenu = computed(() => store.state.permission.isTopMenu);
const topRouterPath = computed(() => store.state.permission.topRouterPath);
const leftRouter = computed(() =>
  store.state.permission.leftRouter.map((item) => {
    if (item.path === "/home") {
      return {
        ...item.children[0],
        path: "/home/index",
      };
    }
    return { ...item };
  })
);

const handleSelect = (key) => {
  router.push({ path: key });
};

const leftRouterFilter = (data, path) => {
  const arr = [];
  data.forEach((item) => {
    if (!item.hidden) {
      const pathStr = path
        ? `${path ? "/" + path + "/" : ""}${item.path}`
        : item.path;
      // 复制菜单项，确保保留children
      const newItem = {
        ...item,
        path: pathStr.replace(/\/\//g, "/"),
      };

      // 递归处理子菜单
      if (item?.children) {
        newItem.children = leftRouterFilter(item.children);
      }
      arr.push(newItem);
    } else if (item.menuType === "M" && item?.children) {
      // 如果是隐藏的目录，且有子菜单，则递归处理子菜单并直接添加到上级目录
      const menuPath =
        item.menuType === "M"
          ? `${path ? "/" + path + "/" : ""}${item.path}`
          : "";
      const filteredChildren = leftRouterFilter(
        item.children,
        menuPath.replace(/\/\//g, "/")
      );
      arr.push(...filteredChildren);
    }
  });
  return arr;
};

function handlePath(item, child, layer) {
  if (item.path === "/home/index") {
    return "/home/index";
  }
  let str = "";
  if (item && child && layer) {
    str = `${
      isTopMenu.value
        ? topRouterPath.value + (item.path.includes("/") ? "" : "/")
        : ""
    }${item.path || ""}/${child.path || ""}/${layer.path || ""}`;
  } else if (item && child) {
    str = `${
      isTopMenu.value
        ? topRouterPath.value + (item.path.includes("/") ? "" : "/")
        : ""
    }${item.path}/${child.path}`;
  } else if (item.path) {
    str = `${
      isTopMenu.value
        ? topRouterPath.value + (item.path.includes("/") ? "" : "/")
        : ""
    }${item.path}`;
  }
  return str.replace(/\/\//g, "/");
}
</script>

<style lang="scss" scoped>
.leftMenu {
  flex: 1;
  min-height: 0;
  padding: 12px 20px 20px;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--app-surface-color);

  :deep(.el-menu) {
    border-right: 0;
    background: transparent;
  }

  :deep(.el-menu-item),
  :deep(.el-sub-menu__title) {
    height: 48px;
    margin: 2px 0;
    padding: 0 28px !important;
    color: var(--app-text-color);
    font-size: var(--app-font-size);
    line-height: 48px;
    border-radius: 10px;
    transition:
      color 0.2s ease,
      background-color 0.2s ease;
  }

  :deep(.el-menu-item:hover),
  :deep(.el-sub-menu__title:hover) {
    color: #f26522;
    background: var(--app-menu-hover-color);
  }

  :deep(.el-menu-item.is-active) {
    color: #f26522;
    font-weight: 600;
    background: var(--app-menu-active-color);
  }

  :deep(.el-sub-menu.is-active > .el-sub-menu__title) {
    color: #f26522;
  }

  :deep(.el-sub-menu .el-menu-item),
  :deep(.el-sub-menu .el-sub-menu__title) {
    min-width: 0;
    padding-left: 28px !important;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #dfe2e7;
    border-radius: 4px;
  }
}
</style>
